import { Adapter as s, getAdapter as i } from "../../../adapter.js";
import { TicketItemModifierAdapter as p } from "../ticketItemModifier/ticketItemModifier.adapter.js";
import { TicketItemAdapter as c } from "../ticketItem/ticketItem.adapter.js";
import { TicketItemComboModel as d } from "./ticketItemCombo.model.js";
class A extends s {
  adapt(e) {
    var t, o;
    const m = i(p), r = i(c);
    return new d(
      {
        itemId: e.item_id,
        refItemId: e.ref_item_id,
        skuCode: e.sku_code,
        name: e.name,
        voucherCode: e.voucher_code,
        quantity: e.quantity,
        subtotal: e.subtotal,
        taxes: e.taxes,
        total: e.total,
        notes: e.notes,
        modifiers: (t = e.modifiers) == null ? void 0 : t.map(m.adapt),
        totalItems: e.total_items,
        combo: e.combo,
        description: e.description,
        items: (o = e.items) == null ? void 0 : o.map(r.adapt)
      }
    );
  }
  serialize(e) {
  }
}
export {
  A as TicketItemComboAdapter
};
//# sourceMappingURL=ticketItemCombo.adapter.js.map
